import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface DeleteProfileDialogData {
  email: string;
}

@Component({
  selector: 'app-delete-profile-dialog',
  templateUrl: './delete-profile-dialog.component.html',
  styleUrl: './delete-profile-dialog.component.scss',
})
export class DeleteProfileDialogComponent implements OnInit {
  deleteProfileForm: FormGroup;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DeleteProfileDialogData,
    private dialogRef: MatDialogRef<DeleteProfileDialogComponent>,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.createForm();

  }

  createForm() {
    this.deleteProfileForm = this.fb.group({
      emailConfirm: [''],
    });
  }

  getControl(name: string): AbstractControl {
    return this.deleteProfileForm?.get(name);
  }

  handleSubmit(event: Event) {
    event.preventDefault();
    const emailInput = this.getControl('emailConfirm').value?.trim().toLowerCase();
    const emailData = this.data.email?.trim().toLowerCase();
    if (emailInput !== emailData) {
      this.errorMessage = this.translateService.instant('public.profile.deleteConfirmEmailError');
      return;
    }
    this.dialogRef.close(true);
  }
}
